<template>
  <div class="map-con"></div>
</template>
  
<script>

  export default {
    name: 'openWebByQuickapp',
    computed: {},
    data(){
      return {
        supportQuickAPP: false
      }
    },
    methods: {
      
    },

    mounted(){
      localStorage.setItem('urlActionNeedReply', true); // 控制是否正常下发
      
      const { name, params, query }  = this.$route;
      console.log('$route ===', this.$route)
      channelReady((bAvailable) => {
        // alert('是否支持快应用：' + bAvailable)
        switch(name){
          case 'openWeb':
            {
              const { s } = query || {};
              if(bAvailable){
                appRouter('com.hetu.message','/Web',{ webSrc: decodeURIComponent(s) })
              }
              location.href = decodeURIComponent(s);
              break;
            }
          case 'openMain':
            {
              const { templateId, platformCode } = params;
              if(bAvailable){
                appRouter('com.hetu.message','/',{ 
                  templateId, platformCode, // queryParams: query 
                })
              }
              this.$router.push({
                name: 'ChatbotList',
                params,
                query
              })
              break;
            }
          default:
            break;
        }
      });
    }
  }
</script>

<style lang="less">
  .alertCon{
    width: 90%;
  }
</style>


// WEBPACK FOOTER //
// src/openByQuickapp/index.vue